export default __webpack_public_path__ + "static/media/Logo-light.9ce23c56.png";